"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FileReaderWriterWrapper = _interopRequireDefault(require("../../../cordovaPluginWrappers/FileReaderWriterWrapper"));

var _CordovaFileHelper = _interopRequireWildcard(require("../../../helpers/CordovaFileHelper"));

var _FileSystemWrapper = _interopRequireDefault(require("../../../cordovaPluginWrappers/FileSystemWrapper"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var CACHE = {};

var Video = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Video, _React$Component);

  var _super = _createSuper(Video);

  function Video(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Video);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "loadB64", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(src) {
        var prefix;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _FileSystemWrapper["default"].getPathPrefix();

              case 2:
                prefix = _context.sent;
                _context.t0 = _FileReaderWriterWrapper["default"];
                _context.next = 6;
                return _CordovaFileHelper["default"].getFileEntry(src.replace(prefix, ''));

              case 6:
                _context.t1 = _context.sent;
                _context.next = 9;
                return _context.t0.readFileAsDataUrl.call(_context.t0, _context.t1);

              case 9:
                CACHE[src] = _context.sent;

                _this.forceUpdate();

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "unloadB64", function () {
      if (CACHE[_this.props.poster]) {
        delete CACHE[_this.props.poster];
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onContextMenu", function (event) {
      event.preventDefault();
      console.log('context menu!');
      return false;
    });
    return _this;
  }

  (0, _createClass2["default"])(Video, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (_DeviceInfoHelper["default"].isiOS()) {
        if (this.props.poster) this.loadB64(this.props.poster);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {// this.unloadB64()
    }
  }, {
    key: "getId",
    value: function getId() {
      return "".concat(this.props.src, "_video");
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          videoId = _this$props.videoId,
          poster = _this$props.poster,
          props = (0, _objectWithoutProperties2["default"])(_this$props, ["videoId", "poster"]);

      if (poster) {
        props['poster'] = CACHE[poster] || poster; // ie shows poster only if no video is available, all other browsers show poster without any condition

        if (_DeviceInfoHelper["default"].isInternetExplorer()) {
          props['preload'] = 'none';
        }
      }

      console.log('video.js', this.props);
      return /*#__PURE__*/_react["default"].createElement("video", (0, _extends2["default"])({
        id: this.props.videoId
      }, props, {
        crossOrigin: 'anonymous',
        onContextMenu: this.onContextMenu,
        playsInline: true
      }), this.props.subtitles ? /*#__PURE__*/_react["default"].createElement("track", {
        label: "Untertitel",
        kind: "subtitles",
        srcLang: "de",
        src: this.props.subtitles,
        "default": true
      }) : null);
    }
  }]);
  return Video;
}(_react["default"].Component);

Video.propTypes = {
  videoId: _propTypes["default"].string,
  poster: _propTypes["default"].string
};
var _default = Video;
exports["default"] = _default;